<template>
  <div class="form-group">
    <label for="year">{{ label }}</label>
    <app-multiselect
      id="year"
      :value="options.find(o => o.value === value)"
      :options="options"
      label="label"
      track-by="value"
      :allow-empty="false"
      @input="option => $emit('input', option.value)"
    />
  </div>
</template>

<script>
import AppMultiselect from '@/components/AppMultiselect'

export default {
  name: 'SeasonSelect',
  components: { AppMultiselect },
  props: {
    value: { type: Number, required: true },
    label: { type: String, default: 'Season Year' }
  },
  data() {
    return {
      years: []
    }
  },
  computed: {
    options() {
      return this.years.map(year => ({ label: year.name, value: year.id }))
    }
  },
  created() {
    const today = this.$store.state.currentDate ? new Date(this.$store.state.currentDate) : new Date()
    const startYear = today.getMonth() < 1 ? today.getFullYear() - 1 : today.getFullYear()

    for (let Y = startYear; Y >= 2019; Y--) {
      this.years.push({ id: Y, name: `${Y} / ${Y + 1}` })
    }

    this.$emit('input', startYear)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SeasonSelect.vue